import React from 'react';
import SectionHeader from './SectionHeader';
import ContactAside from './ContactAside';
import ContactForm from './ContactForm';
import { useLocale } from '../context/LocaleContext';

const HomeContactSection = ({
  id = 'contact',
  sectionClassName = 'rihen-section home-contact-section',
}) => {
  const { t } = useLocale();

  return (
    <section className={sectionClassName} id={id}>
      <div className="rihen-site-inner">
        <div className="home-contact-section__shell" data-reveal="scale">
          <div className="home-contact-section__layout">
            <div className="home-contact-section__primary">
              <SectionHeader
                eyebrow={t('contact_badge')}
                title={t('contact_title_line1')}
                titleLine2={t('contact_title_line2')}
                titleClassName="hero-manifest__title hero-manifest__title--on-surface"
                centered={false}
                className="home-contact-section__head"
              />
              <ContactAside />
            </div>

            <div className="home-contact-section__form">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeContactSection;
